import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';
import { environment } from '../../../../environments/environment';
import { MainService } from '../../../services/main/main.service';
import { getUserProfile, getUserProfiles } from 'src/app/core/session';
@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {
  changePwdForm: UntypedFormGroup;
  invalidType: any = 0;
  passwordPolicyContainer: boolean = false;
  showCurrPassword: boolean = false;
  showNewPassword: boolean = false;
  showConfirmPassword: boolean = false;
  realValue: string = '';
  realValueConfirm: string = '';
  @ViewChild('passwordContainer', { static: false }) passwordContainer: ElementRef;
  constructor(
    private fb: UntypedFormBuilder,
    public mainService: MainService
  ) { }


  ngOnInit() {
    this.initPassword()
  }

  initPassword() {
    this.changePwdForm = this.fb.group({
      'c_pass': ['', [Validators.required]],
      'n_pass': ['', [Validators.required, this.passwordPolicyValidator()]],
      'rn_pass': ['', [Validators.required]],
    }, { validator: [this.checkIfFieldsAreMatching('n_pass', 'rn_pass'),  this.checkIfNewAndCurrentAreDifferent('c_pass', 'n_pass')] });
    this.invalidType = 0;
  }

  changePwd() {
    if (this.changePwdForm.valid) {
      let params = {
        access_token: localStorage.getItem('token'),
        old_password: this.mainService.encryptInMD5(this.changePwdForm.controls.c_pass.value),
        new_password: this.mainService.encryptInMD5(this.changePwdForm.controls.rn_pass.value),
        device_type: environment.device_type,
        device_token: environment.device_token,
        app_type: environment.app_type,
        app_version: environment.app_version,
        device_id: localStorage.getItem('user'),
      }
      let route = this.userType() == 4 ? "change_password" : "change_password"
      this.mainService.api(params, route, true)
        .subscribe((data: any) => {
          if (data.is_error == 0) {
            setTimeout(() => {
              this.mainService.customPopups('Password has been changed successfully.', 0);
              this.changePwdForm.reset();
              this.mainService.init();
            }, 100)
          }
        })
    }
    else if (this.changePwdForm.invalid && this, this.changePwdForm.controls.c_pass.invalid) {
      this.mainService.customPopups('Enter valid current password.', 1)
    }
    else if (this.changePwdForm.invalid && this, this.changePwdForm.controls.n_pass.invalid) {
      this.mainService.customPopups('Enter a valid new password.', 1)
    }
    else if (this.changePwdForm.invalid && this.changePwdForm.controls.rn_pass.invalid) {
      this.mainService.customPopups('New password and confirm password do not match.', 1)
    }
    else {
      return;
    }
  }

  private checkIfFieldsAreMatching(originalKey: string, matchingKey: string) {
    return (group: UntypedFormGroup) => {
      let passwordInput = group.controls[originalKey],
        passwordConfirmationInput = group.controls[matchingKey];
      if (passwordInput.value !== passwordConfirmationInput.value) {
        return passwordConfirmationInput.setErrors({ notEquivalent: true })
      }
      else {
        return passwordConfirmationInput.setErrors(null);
      }
    }
  }
  checkIfNewAndCurrentAreDifferent(oldKey: string, newKey: string) {
  return (group: UntypedFormGroup) => {
    const old_password = group.controls[oldKey];
    const new_password = group.controls[newKey];

    if (old_password && new_password) {
      const oldValue = old_password.value;
      const newValue = new_password.value;

      if (oldValue === newValue) {
        const currentErrors = new_password.errors || {};
        new_password.setErrors({ ...currentErrors, samepassword: true });
      } else {
        const currentErrors = new_password.errors || {};
        if (currentErrors['samepassword']) {
          delete currentErrors['samepassword'];
          new_password.setErrors(Object.keys(currentErrors).length ? currentErrors : null);
        }
      }
    }

    return null;
  };
  }

  passwordPolicyValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value || '';
    const errors: ValidationErrors = {};

    if (value.length < 8) {
      errors['minLength'] = true;
    }
    if (!/[a-z]/.test(value)) {
      errors['lowercase'] = true;
    }
    if (!/[A-Z]/.test(value)) {
      errors['uppercase'] = true;
    }
    if (!/\d/.test(value)) {
      errors['number'] = true;
    }
    if (!/[!@#$%^&*]/.test(value)) {
      errors['specialChar'] = true;
    }
    if(value && value[value.length-1] == ' '){
      errors['trailingspace'] =true;
    }

    return Object.keys(errors).length ? errors : null;
    };
  }

  showPasswordPolicyContainer(){
    this.passwordPolicyContainer = true;
  }

  hidePasswordPolicyContainer(){
    this.passwordPolicyContainer = false;
    if(this.changePwdForm.controls.n_pass.value === this.changePwdForm.controls.c_pass.value){
      this.mainService.customPopups("Current password and new password should not be same",2);
    }
    if(this.changePwdForm.controls.n_pass.touched && this.changePwdForm.controls.n_pass.errors && this.changePwdForm.controls.n_pass.errors.trailingspace){
      this.mainService.customPopups("Please don’t end your password with blank space.",2);
    }
  }
  userType() {
    let userType = localStorage.getItem('userProfileData') && getUserProfiles() && getUserProfile() && getUserProfile();
    return userType.role_id;
  }

  get displayedValue(): string {
    return this.showNewPassword ? this.realValue : '•'.repeat(this.realValue.length);
  }

  get displayedValueConfirm(): string {
    return this.showConfirmPassword ? this.realValueConfirm : '•'.repeat(this.realValueConfirm.length);
  }

  handleInput(event: Event) {
    const input = event.target as HTMLInputElement;
    const newValue = input.value;

    if (this.showNewPassword) {
      this.realValue = newValue;
    } else {
      if (newValue.length < this.realValue.length) {
        this.realValue = this.realValue.slice(0, newValue.length);
      } else {
        const addedText = newValue.slice(this.realValue.length);
        this.realValue += addedText;
      }
    }
    this.changePwdForm.controls.n_pass.setValue(this.realValue, { emitEvent: true });
  }

  handleInputConfirm(event: Event) {
    const input = event.target as HTMLInputElement;
    const newValue = input.value;

    if (this.showConfirmPassword) {
      this.realValueConfirm = newValue;
    } else {
      if (newValue.length < this.realValueConfirm.length) {
        this.realValueConfirm = this.realValueConfirm.slice(0, newValue.length);
      } else {
        const addedText = newValue.slice(this.realValueConfirm.length);
        this.realValueConfirm += addedText;
      }
    }
    this.changePwdForm.controls.rn_pass.setValue(this.realValueConfirm, { emitEvent: true });
  }

}
